/**
 * Drives the left-edge CMYK scroll-progress bar. (The earlier rolling
 * crosshair icon was removed per feedback — it didn't communicate
 * anything and just felt like noise. The progress bar alone is the keeper.)
 * The per-section "CMYK layers snap into register" effect still happens,
 * but now lives on the image itself — see press-sheets.js.
 */
export function initRegistrationMark(gsap, ScrollTrigger) {
  const fill = document.querySelector('.reg-mark__progress-fill');
  if (!fill) return;

  ScrollTrigger.create({
    trigger: document.body,
    start: 'top top',
    end: 'bottom bottom',
    onUpdate: (self) => {
      fill.style.height = `${self.progress * 100}%`;
    },
  });
}
